<style>
.select2-container--default .select2-selection--single .select2-selection__clear{
    height: 25px;
    width: 28px;
    padding-left: 3px;
    padding-top: 3px;
    margin-right: 20px;
    background-color: transparent;
    margin-top: 4px;
}
.select2-container .select2-selection--single{
    height: 38px !important;
}
.select2-container .select2-selection--single .select2-selection__rendered{
    margin-top: 5px;
    font-size: 12px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
    margin-top: 5px;
    margin-right: 10px;
    background: url(/shop/images/arrow.svg) no-repeat center;
    width: 9px;
}
.select2-container--default .select2-selection--single .select2-selection__placeholder {
    color: black  !important;
    font-size: 12px;
}
.select2-container--default .select2-selection--single{
    border: 1px solid #d2d2d2;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b{
    border-style: none;
}
.select2-results__option[aria-selected]{
    font-size: 12px;
}
</style>
<template id="select2-template">
    <select style="width:100%"></select>
</template>
<script type="text/javascript">
import select2 from 'select2';

export default {
    components: {
        select2
    },
    props: ["options", "value","url"],
    template: "#select2-template",
    data: function() {
        return {
            ajaxOptions: {
                url: this.url,
                dataType: 'json',
                data: function(params) {
                    return {
                        term: params.term, // search term
                        page: params.page
                    };
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;
                    return {
                        results:data.items,
                    };
                },
                cache: true
            }
        };
    },
    mounted: function() {
        var vm = this;
        $(this.$el)
            // init select2
            .select2({
                placeholder:"Select",
                ajax:vm.ajaxOptions,
                allowClear:true
            })
            .val(this.values)
            .trigger("change")
            // emit event on change.
            .on("change", function() {
                vm.$emit("input", this.value);
            }).on('select2:clear',function(){
              vm.$emit("input",{});
            }).append(new Option(this.value, this.value, false, false));
    },
    watch: {
        value: function(value) {
            // update value
            $(this.$el).val(value).trigger('change.select2');
        },
        options: function(options) {
            // update options
            $(this.$el).empty().select2({data: options})
        },
        url:function(newUrl) {
            this.ajaxOptions.url = newUrl;
            $(this.$el).empty().select2({
                placeholder: "Select",
                ajax: this.ajaxOptions,
                allowClear: true,
            });
        }
    },
    destroyed: function() {
        $(this.$el)
            .off()
            .select2("destroy");
    }
};

</script>
